<template>
  <div>
    <p class="is-size-3 has-text-weight-bold">
      {{ $t("mp:application.waiting.title") }}
    </p>

    <div class="is-flex">
      <img
        :src="require('@/assets/images/flow-waiting.svg')"
        alt="flow-waiting"
      />
      <div class="has-text-grey ml-5 mt-3">
        {{ $t("mp:application.waiting.description") }}
      </div>
    </div>

    <div class="info-box mt-5">
      <p class="has-text-weight-bold mb-1">
        {{ $t("mp:application.waiting.info_box.title") }}
      </p>
      <p class="mb-1 ml-2">
        • {{ $t("mp:application.waiting.info_box.line_one") }}
      </p>
      <p class="ml-2">• {{ $t("mp:application.waiting.info_box.line_two") }}</p>
    </div>
  </div>
</template>

<script>
import { USER_STATUS } from "../utils/const";

export default {
  name: "ApplicationCheck",
  title: "mp:page.application_check.title",
  data() {
    return {
      poll: null,
    };
  },
  async mounted() {
    if (
      !this.$store.getters["profile/isInState"](USER_STATUS.WAITING_FOR_FLOW)
    ) {
      return await this.$router.push(
        this.$store.getters["profile/getBackPath"]
      );
    }
    await this.checkFlow();

    this.poll = window.setInterval(async () => {
      await this.checkFlow();
    }, 30000);
  },
  methods: {
    async checkFlow() {
      await this.$store.dispatch("application/pollStatus");

      if (this.$store.getters["application/applicationStatus"]) {
        await this.$store.dispatch(
          "profile/updateStatusLocal",
          USER_STATUS.IN_FLOW
        );
        await this.$router.push({
          name: "Application",
        });
      }
    },
  },
  beforeDestroy() {
    window.clearInterval(this.poll);
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/colors.scss";

.info-box {
  background: $grey-2;
  border-radius: 8px;
  padding: 1.5rem 2rem;
}
</style>
